import K from "./constants";

export const isFinalStatus = (type) => type === K.Status.Type.Final;

export const isHiredStatus = (type) => type === K.Status.Type.Hired;

export const isActiveStatus = (type) => type === K.Status.Type.Active;

export const getCandidateStatusKey = (
  statusId,
  subStatusId,
  otherStatusId = null,
) => {
  return [statusId, subStatusId, otherStatusId].filter(Boolean).join("-");
};
